import React, { Component } from "react";
import ToastIcon from "./img/toast-icon.svg";
// import colors from 'styles/_exports.module.scss';

import "./Toast.scss";

import { withTranslation } from "react-i18next";

const CloseButton = ({ closeToast, t }) => (
  <i
    role="button"
    tabIndex={0}
    style={{
      position: "absolute",
      top: "4px",
      right: "4px",
      fontStyle: "normal",
    }}
    className="material-icons"
    aria-label={t("close alert")}
    onKeyPress={closeToast}
    onClick={closeToast}
  >
    ✖
  </i>
);

class Toast extends Component {
  genIconContainer = () => {
    // let color = colors.charcoal1

    switch (this.props.type) {
      case "WARNING":
        // color = colors.red2
        break;

      case "HINT":
        // color = colors.yellow1
        break;

      default:
        break;
    }

    return (
      <div className="toast-img-container">
        <img
          className="toast-icon"
          src={ToastIcon}
          alt={"popup icon " + this.props.type}
        />
      </div>
    );
  };

  componentDidMount() {
    this.toast.focus();
  }

  render() {
    return (
      //<FocusLock disabled={false}>
      <div className="toast-container">
        <CloseButton t={this.props.t} closeToast={this.props.closeToast} />
        {this.genIconContainer()}
        <div
          role="button"
          tabIndex={0}
          className="toast-text-container"
          data-autofocus
          ref={(toast) => {
            this.toast = toast;
          }}
          onClick={this.props.closeToast}
          onKeyDown={this.props.closeToast}
        >
          <p className="toast-text-heading">{this.props.t(this.props.title)}</p>
          <p className="toast-text-message">{this.props.t(this.props.msg)}</p>
        </div>
      </div>
      //</FocusLock>
    );
  }
}

export default withTranslation()(Toast);
